namespace e5 {
    export class Player {
        /**
        * callback: ():void
        */
        public static onTick = Signal.create();
        public static tickCount: number = 0;
        public static get enabled(): boolean {
            return Ticker.getEnabled();
        }

        public static set enabled(value: boolean) {
            Ticker.setEnabled(value);
        }
    }

    class Ticker {
        private static _handle: number;
        private static _enabled: boolean = false;
        private static _created: boolean = false;

        public static getEnabled(): boolean {
            return this._enabled;
        }

        public static setEnabled(value: boolean): void {
            if (Ticker._enabled == value)
                return;
            Ticker._enabled = value;

            if (!Ticker._created)
                Ticker.create();

            if (Ticker._enabled) {
                Ticker._enabled = true;
                Ticker.handleTick();
            }
            else {
                window.cancelAnimationFrame(Ticker._handle);
            }
        }

        private static handleTick(): void {
            Player.tickCount++;
            Ticker._handle = window.requestAnimationFrame(Ticker.handleTick);
            Player.onTick.dispatch();
        }

        //source: http://paulirish.com/2011/requestanimationframe-for-smart-animating/
        private static create(): void {
            var lastTime = 0;
            var vendors = ['webkit', 'moz'];
            for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
                window.requestAnimationFrame = (<any>window)[vendors[x] + 'RequestAnimationFrame'];
                window.cancelAnimationFrame =
                    (<any>window)[vendors[x] + 'CancelAnimationFrame'] || (<any>window)[vendors[x] + 'CancelRequestAnimationFrame'];
            }

            if (!window.requestAnimationFrame)
                window.requestAnimationFrame = function (callback): number {
                    var currTime = new Date().getTime();
                    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                    var id: number = window.setTimeout(function () { callback(currTime + timeToCall); },
                      timeToCall);
                    lastTime = currTime + timeToCall;
                    return id;
                };

            if (!window.cancelAnimationFrame)
                window.cancelAnimationFrame = function (id) {
                    clearTimeout(id);
                };
        }
    }

    e5.Player.enabled = true;
}